import React from "react";
import { Link } from "react-router-dom";

const LINK_RE = /\[([^\]]+)\]\((\/[^)\s]*)\)/g;

// Renders plain text containing [anchor](/path) inline links as router Links
export const renderRichText = (text) => {
  if (!text || text.indexOf("[") === -1) return text;
  const parts = [];
  let last = 0;
  let m;
  LINK_RE.lastIndex = 0;
  while ((m = LINK_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    parts.push(
      <Link
        key={`${m[2]}-${m.index}`}
        to={m[2]}
        className="text-brand font-medium underline underline-offset-4 decoration-brand/40 hover:decoration-brand transition-colors"
      >
        {m[1]}
      </Link>
    );
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
};
